const publicUrl = process.env.PUBLIC_URL;

export const WEBSITE_PROJECTS = [
  {
    id: "smart-sps",
    title: "Smart SPS",
    category: "Education",
    url: "https://www.smartsps.com/",
    image: `${publicUrl}/portfolio/websites/smart-sps.png`,
    description:
      "Education platform focused on shaping the future of learning with modern web solutions.",
  },
  {
    id: "codeffy",
    title: "Codeffy Solutions",
    category: "Web Development",
    url: "https://codeffy.com/",
    image: `${publicUrl}/portfolio/websites/codeffy.PNG`,
    description:
      "Business website with AI integrations, services, projects, and modern digital solutions.",
  },
  {
    id: "workzen",
    title: "WorkZen",
    category: "Digital Marketing",
    url: "https://workzen.co/",
    image: `${publicUrl}/portfolio/websites/workzen-co.png`,
    description:
      "Digital marketing website built for business growth and online brand presence.",
  },
  {
    id: "munch-addict",
    title: "Global Munch",
    category: "E Commerce",
    url: "https://munchaddict.netlify.app/",
    image: `${publicUrl}/portfolio/websites/munch-addict.PNG`,
    description:
      "E commerce snack store with product listings, cart flow, and a bold shopping experience.",
  },
  {
    id: "oranti-homes",
    title: "O Ranti Homes",
    category: "Real Estate",
    url: "https://orantihomes.netlify.app/",
    image: `${publicUrl}/portfolio/websites/oranti-homes.jpg`,
    description:
      "Real estate website with property listings, contact forms, and location based content.",
  },
  {
    id: "everything-ai",
    title: "Everything AI Now",
    category: "AI",
    url: "https://everythingainow.com/",
    image: `${publicUrl}/portfolio/websites/everything-ai.jpg`,
    description:
      "AI focused website showcasing modern tools, content, and digital innovation.",
  },
];

export const SOFTWARE_PROJECTS = [
  {
    id: "smart-tuition",
    title: "Smart Tuition",
    category: "LMS",
    image: `${publicUrl}/portfolio/softwares/smart-tuition.png`,
    description:
      "Learning management style system for managing tuition, students, and education workflows.",
    contactOnly: true,
  },
  {
    id: "supply-teachers",
    title: "Supply Teachers",
    category: "Education System",
    image: `${publicUrl}/portfolio/softwares/supply-teachers.png`,
    description:
      "Platform for managing supply teachers, bookings, and school staffing needs.",
    contactOnly: true,
  },
  {
    id: "chat-platform",
    title: "Team Chat Platform",
    category: "Communication System",
    image: `${publicUrl}/portfolio/softwares/chat-platform.png`,
    description:
      "Custom team chat platform built for business communication and internal messaging.",
    contactOnly: true,
  },
  {
    id: "task-manager",
    title: "Task Manager",
    category: "Business System",
    image: `${publicUrl}/portfolio/softwares/task-manager.png`,
    description:
      "Task management system for tracking work, assignments, and team productivity.",
    contactOnly: true,
  },
  {
    id: "progress-tracker",
    title: "Progress Tracker",
    category: "Business System",
    image: `${publicUrl}/portfolio/softwares/progress-tracker.png`,
    description:
      "Progress tracking software for monitoring projects, goals, and performance over time.",
    contactOnly: true,
  },
];

export const SOFTWARE_ACCESS_NOTE =
  "Direct links to private software are not available here. For details and access, please contact the admin.";
